import { Box, List, ListItem, ListItemIcon } from '@mui/material'
import React from 'react'

function Disclamer() {
	const text = 'All offers presented by Carwiser come directly from qualified dealers participating in our CarwiserXchange marketplace. All offers are contingent on your providing accurate information via Carwiser.com. Each dealer maintains the right to conduct an in-person verification of your vehicle and evaluate other vehicle use and history information prior to finalizing their offer. Any differences between the information you provide about your vehicle and the vehicle’s actual condition, use, and history may impact the offer you receive from the dealer. Carwiser is making no offer to purchase your vehicle and in no way should be considered a party to the transaction.'
	return (
		<List sx={{
			p: 0,
			color: '#2A2F31',
		}}>
			<ListItem sx={{
				alignItems: 'flex-start',
				m: 0,
				mt: '40px',
				mb: '40px',
				p: 0,
				'& .MuiListItemIcon-root': {
					minWidth: '12px'
				},
				fontSize: '10px',
				lineHeight: '12px',
				fontWeight: 400,
				color: '#2A2F31',
			}}>
				<ListItemIcon sx={{
					// display: 'inline-block',
					fontSize: '18px',
					fontWeight: 400,
					color: '#2BACE2',
					textAlign: 'center',
					marginTop: '4px',
				}}>*</ListItemIcon>
				<Box dangerouslySetInnerHTML={{__html: text}}></Box>
			</ListItem>
		</List>
	)
}

export default Disclamer